import React, { useContext, ReactNode } from "react";
import classnames from "classnames";
import Styles from "./Features.module.scss";
import { AppContext } from "@vahak/core/dist/app-context";
import Link from "next/link";
import AppImg from "components/utils/AppImg";

// Icons
import ArrowRightWhite from "@vahak/core/dist/icons/arrow-right-white.svg";
import { sanitize } from "isomorphic-dompurify";

interface FeaturesProps {
    features: any;
    sectionTitle: ReactNode;
    sectionText?: string;
    ctaLink: string;
    ctaLabel: string;
    ctaClass?: string;
    onCtaClick?: Function;
    sectionClass?: string;
    featureCardClass?: string;
}

interface DataProps {
    id: number;
    tabTitle: string;
    description: string;
    image: string;
    srcset: string;
    altText?: string;
}

// sectionClass and featureClass is used currently to support latest changes on logistics services page.
// Should be removed when all pages using features component are updated.
const Features = ({
    features,
    sectionTitle,
    sectionText,
    ctaLink,
    ctaLabel,
    ctaClass,
    onCtaClick,
    sectionClass,
    featureCardClass
}: FeaturesProps) => {
    const { isMobile } = useContext(AppContext);

    return (
        <section className={classnames(Styles.main, sectionClass)}>
            <div className={classnames(Styles.conainer, "container")}>
                <div className={Styles.heading}>
                    <h2>{sectionTitle}</h2>
                    <p>{sectionText}</p>
                </div>
            </div>

            <div className={Styles.featuresWrap}>
                {features.map((data: DataProps) => (
                    <div className={classnames(Styles.featureCard, featureCardClass)} key={data.id}>
                        <div className="container">
                            <div className={Styles.featureRow}>
                                <div className={Styles.imgCol}>
                                    <div className={Styles.imgBox}>
                                        <AppImg
                                            src={data.image}
                                            layout="responsive"
                                            alt={data.altText}
                                            width={isMobile ? "180" : "400"}
                                            height={isMobile ? "180" : "400"}
                                        />
                                    </div>
                                </div>
                                <div className={Styles.textCol}>
                                    <div className={Styles.textBox}>
                                        <h3>{data.tabTitle}</h3>
                                        <p dangerouslySetInnerHTML={{ __html: sanitize(data.description) }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                <div className={classnames(Styles.featureBtnWrapper, ctaClass)}>
                    <Link
                        href={ctaLink}
                        prefetch={false}
                        target="_blank"
                        onClick={() => {
                            onCtaClick && onCtaClick();
                        }}
                    >
                        {ctaLabel} <ArrowRightWhite width="14" height="15" />
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Features;
